import React, { useState } from "react";
import { Nav as MNav } from "@magnetic/nav";
import NavDrawerContent from "./nav-drawer-content";
import NavItem from "./nav-item";
import "./nav.scss";

export default function NavMenu({ navConfig, navMenuItems, i18nNamespace, i18n, basePath, navItemClick, disableItems, customClassName }) {
  const { initialIsCollapsed, isIconOnly } = navConfig;
  const { menuItems = [], drawerItems = [] } = navMenuItems;

  const [, setCurrentPath] = useState("");

  const getActive = (item) => {
    let active = false;
    if (item.href && window.location.pathname === `/${item.href}`) {
      active = true;
    }
    if (item.href && window.location.pathname.includes(item.href) && item.href !== "/") {
      active = true;
    }
    if (item.href && item.href === "/" && window.location.pathname === "/") {
      active = true;
    }

    if (item.drawerContentId) {
      const drawer = drawerItems.find((d) => d.drawerId === item.drawerContentId);
      const childItems = [];
      if (drawer && drawer.items?.length > 0) {
        drawer.items.forEach((i) => {
          if (i.href) {
            childItems.push(`/${i.href}`);
          }
        });
      }
      if (childItems.includes(window.location.pathname)) {
        active = true;
      }
    }
    return active;
  };

  window.addEventListener("single-spa:before-routing-event", (evt) => {
    setCurrentPath(evt.detail.originalEvent?.target?.location.pathname || "");
  });

  console.log("Menu items ---", menuItems);

  return (
    <MNav key="nav" className={`sticky-nav ${customClassName}`} navZIndex={9} initialIsCollapsed={initialIsCollapsed} isIconOnly={isIconOnly}>
      <MNav.Collapse />
      {/* Menu */}
      <MNav.Menu>
        {menuItems.map((item) => (
          <NavItem key={item.id} item={item} i18nNamespace={i18nNamespace} i18n={i18n} navItemClick={navItemClick} getActive={getActive} />
        ))}
      </MNav.Menu>
      {/* Drawer */}
      <MNav.Drawer className="nav-menu_drawer">
        {drawerItems.map((ditem) => (
          <NavDrawerContent disableItems={disableItems} key={ditem.id} drawer={ditem} i18nNamespace={i18nNamespace} i18n={i18n} basePath={basePath} navItemClick={navItemClick} />
        ))}
      </MNav.Drawer>
    </MNav>
  );
}
